import React, { useRef } from "react";
import classNames from "classnames";
import "./index.scss";
import { IPlateNumber } from "../../types/driver.interface";

type Props = {
  tagNum: IPlateNumber;
  editor: boolean;
  onChange: (tag: IPlateNumber) => void;
};

const PlateNumber = ({ tagNum, editor, onChange }: Props) => {
  const inputLetter = useRef<HTMLInputElement>(null);
  const inputThree = useRef<HTMLInputElement>(null);
  const inputLocation = useRef<HTMLInputElement>(null);

  const inputStyle = classNames("input-style", "input", {
    disabled: editor === false,
  });
  const imageCarTag = require("./carTag.png");

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const persianRegex = /^[\u0600-\u06FF\s]+$/;
    const inputValue = event.target.value;
    console.log(inputValue.match(persianRegex));

    if (editor === true) {
      if (inputValue.match(persianRegex)) {
        onChange({
          ...tagNum,
          letter: event.currentTarget.value,
        });
        if (String(event.currentTarget.value) !== "") {
          inputThree?.current?.focus();
        }
      } else {
        onChange({
          ...tagNum,
          letter: "",
        });
      }
    }
  }

  return (
    <div id="custom-car-tag-content">
      <img className="car-tag-image" src={imageCarTag} alt="car-tag" />
      <div className="input-two-number">
        <input
          className={inputStyle}
          type="text"
          value={tagNum?.twoDigit !== "0" ? tagNum?.twoDigit : ""}
          maxLength={2}
          onChange={(e) => {
            editor === true &&
              onChange({
                ...tagNum,
                twoDigit: e.currentTarget.value,
              });
            if (Number(e.currentTarget.value) >= 10) {
              inputLetter?.current?.focus();
            }
          }}
        />
      </div>
      <div className="input-letter">
        <input
          className={inputStyle}
          type="text"
          value={tagNum?.letter}
          maxLength={1}
          ref={inputLetter}
          onChange={handleInputChange}
        />
      </div>
      <div className="input-three-number">
        <input
          className={inputStyle}
          type="text"
          value={tagNum?.threeDigit ? tagNum.threeDigit : ""}
          maxLength={3}
          ref={inputThree}
          onChange={(e) => {
            editor === true &&
              onChange({
                ...tagNum,
                threeDigit: e.currentTarget.value,
              });
            if (Number(e.currentTarget.value) >= 100) {
              inputLocation?.current?.focus();
            }
          }}
        />
      </div>
      <div className="input-location-number">
        <input
          className={inputStyle}
          type="text"
          value={tagNum?.iran ? tagNum.iran : ""}
          maxLength={2}
          ref={inputLocation}
          onChange={(e) => {
            editor === true &&
              onChange({
                ...tagNum,
                iran: e.currentTarget.value,
              });
          }}
        />
      </div>
    </div>
  );
};

export default PlateNumber;
